/**
 * Blaze Slider drag guard — ends a drag whose pointerup never reached the track.
 *
 * blaze-slider captures the pointer on the element you grabbed
 * (utils/drag.ts: `el.setPointerCapture(downEvent.pointerId)` where el =
 * downEvent.target) but listens for `pointerup` on the TRACK. In loop mode a
 * mid-drag prev()/next() reorders the slides, so the grabbed node — typically a
 * <video>, which is why QA hit this by grabbing videos — can be moved or
 * detached. Its pointerup then never reaches the track, the pointermove listener
 * is never removed, and the carousel keeps following the mouse until the next
 * click ("mouse locked in the carousel", QA Sep 2026).
 *
 * Re-dispatching pointerup on the track lets blaze's own handler do the cleanup.
 * When the real event did reach the track, blaze has already removed that
 * listener, so the extra dispatch is a no-op — no double-advance.
 */
(function () {
  var pending = [];

  document.addEventListener(
    'pointerdown',
    function (event) {
      var track = event.target && event.target.closest ? event.target.closest('.blaze-track') : null;
      if (track && pending.indexOf(track) === -1) pending.push(track);
    },
    true
  );

  function endDrags(event) {
    if (!pending.length) return;
    var tracks = pending;
    pending = [];
    tracks.forEach(function (track) {
      // Released inside the track: blaze's own listener has it.
      if (event && event.target && track.contains(event.target)) return;
      try {
        track.dispatchEvent(
          new PointerEvent('pointerup', {
            bubbles: false,
            pointerId: (event && event.pointerId) || 1,
            pointerType: 'mouse',
            clientX: (event && event.clientX) || 0,
            clientY: (event && event.clientY) || 0
          })
        );
      } catch (e) {
        /* no PointerEvent constructor: nothing to clean up */
      }
    });
  }

  document.addEventListener('pointerup', endDrags, true);
  document.addEventListener('pointercancel', endDrags, true);
  window.addEventListener('blur', function () {
    endDrags(null);
  });
})();
